import * as React from "react";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import Routes from "routing/Routes";
import { MenuItem, DeleteMenuItem, BootstrapModalConfirm } from "components/bootstrap";
import { Spinner } from "components/common";
import useScopePermissions from "hooks/useScopePermissions";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import { useDeleteDataAdapter } from "components/lookup-tables/hooks/useLookupTablesAPI";
import { MoreActionsMenu } from "components/common/MoreActions";
function Actions({ adapter }) {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const sendTelemetry = useSendTelemetry();
  const { deleteDataAdapter, deletingDataAdapter } = useDeleteDataAdapter();
  const { loadingScopePermissions, scopePermissions } = useScopePermissions(adapter);
  const navigate = useNavigate();
  const handleEdit = useCallback(() => {
    navigate(Routes.SYSTEM.LOOKUPTABLES.DATA_ADAPTERS.edit(adapter.name));
  }, [adapter, navigate]);
  const handleDelete = useCallback(() => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.LUT.DATA_ADAPTER_DELETED, {
      app_pathname: "lut",
      app_section: "lut_data_adapter"
    });
    deleteDataAdapter(adapter.id).then(() => setShowDeleteModal(false));
  }, [adapter.id, sendTelemetry, deleteDataAdapter]);
  if (loadingScopePermissions) return /* @__PURE__ */ React.createElement(Spinner, { text: "" });
  if (!scopePermissions.is_mutable) return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MoreActionsMenu, { id: adapter.id, size: "lg", pullRight: true, title: `More Actions for ${adapter.name}` }, /* @__PURE__ */ React.createElement(MenuItem, { onSelect: handleEdit }, "Edit"), /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), /* @__PURE__ */ React.createElement(DeleteMenuItem, { onSelect: () => setShowDeleteModal(true) }, "Delete")), showDeleteModal && /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      showModal: true,
      title: "Delete Data Adapter",
      onCancel: () => setShowDeleteModal(false),
      onConfirm: handleDelete,
      cancelButtonDisabled: deletingDataAdapter,
      confirmButtonDisabled: deletingDataAdapter,
      confirmButtonText: "Delete"
    },
    /* @__PURE__ */ React.createElement("p", null, 'Are you sure you want to delete the data adapter "', adapter.title, '"?')
  ));
}
const renderActions = (adapter) => /* @__PURE__ */ React.createElement(Actions, { adapter });
function useActions() {
  return {
    renderActions
  };
}
export default useActions;
